import { render } from "./ContentComponent.vue?vue&type=template&id=58faafe8&scoped=true"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"

import "./ContentComponent.vue?vue&type=style&index=0&id=58faafe8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58faafe8"]])

export default __exports__